import { UserSessionInterface } from '../interfaces/userSession';

export class UserSession implements UserSessionInterface {
    IDUserSession?: number;
    DateStart: Date;
    Token: string;

    constructor() {
        this.DateStart = new Date();
        this.Token = '';
    }
}
